import autotunerLogo from "@/assets/tool-logos/autotuner.png";
import alientechLogo from "@/assets/tool-logos/alientech.png";
import magicmotorsportLogo from "@/assets/tool-logos/magicmotorsport.png";

const LOGOS = {
  autotuner: autotunerLogo,
  alientech: alientechLogo,
  magicmotorsport: magicmotorsportLogo,
};

const LABELS = {
  autotuner: "Autotuner",
  alientech: "Alientech",
  magicmotorsport: "MagicMotorsport",
  dynoecu: "Original ECU Dateien",
};

// Real logo artwork is rendered without a surrounding chip so transparent
// images blend directly into the page. Sources without artwork keep a small
// text-only fallback.
export default function ToolLogo({ source, className = "h-5", chipClassName = "" }) {
  const src = LOGOS[source];
  const label = LABELS[source];
  if (!src && !label) return null;
  return (
    <span className={`inline-flex items-center justify-center shrink-0 ${chipClassName}`}>
      {src ? (
        <img src={src} alt={label || source} className={`w-auto object-contain ${className}`} />
      ) : (
        <span className="text-[10px] font-medium text-neutral-200 whitespace-nowrap">
          {label}
        </span>
      )}
    </span>
  );
}
